import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { StyledContent, StyledContentWrapper, StyledLabel, StyledLabelsWrapper, StyledWrapper, } from './Tabs.style';
export function TabsLabels({ activeIndex, items, onClick, variant = 'default', }) {
    return (_jsx(StyledLabelsWrapper, { variant: variant, children: items.map((item, index) => (_jsx(StyledLabel, { variant: variant, isActive: activeIndex === index, onClick: () => onClick === null || onClick === void 0 ? void 0 : onClick(index), children: item.label }, `tab-label-${item.label}`))) }));
}
export function TabsContent({ activeIndex, items, }) {
    return (_jsx(StyledContentWrapper, { className: "tabs-content-wrapper", children: items.map((item, index) => (_jsx(StyledContent, { isActive: activeIndex === index, className: "tabs-content", children: item.content }, `tab-label-${item.label}`))) }));
}
export function Tabs({ activeIndex, items, onTabChange, variant = 'default', }) {
    const [activeTab, setActiveTab] = useState(activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0);
    useEffect(() => {
        const newActiveTab = activeIndex !== null && activeIndex !== void 0 ? activeIndex : 0;
        if (newActiveTab === activeTab)
            return;
        setActiveTab(newActiveTab);
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(newActiveTab);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [activeIndex]);
    const handleTabClick = (key) => {
        setActiveTab(key);
        onTabChange === null || onTabChange === void 0 ? void 0 : onTabChange(key);
    };
    return (_jsxs(StyledWrapper, { className: "tabs-wrapper", children: [_jsx(TabsLabels, { items: items, activeIndex: activeTab, onClick: handleTabClick, variant: variant }), _jsx(TabsContent, { items: items, activeIndex: activeTab })] }));
}
//# sourceMappingURL=Tabs.js.map